import { render, staticRenderFns } from "./BookAudiosPreview.vue?vue&type=template&id=29b33d2b&scoped=true"
import script from "./BookAudiosPreview.vue?vue&type=script&lang=js"
export * from "./BookAudiosPreview.vue?vue&type=script&lang=js"
import style0 from "./BookAudiosPreview.vue?vue&type=style&index=0&id=29b33d2b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b33d2b",
  null
  
)

export default component.exports